import PopUpReminderDialog from './PopUpReminderDialog';

export default PopUpReminderDialog;
